import { render, staticRenderFns } from "./SaleOrderForm.vue?vue&type=template&id=6f63e7f6&scoped=true&"
import script from "./SaleOrderForm.vue?vue&type=script&lang=js&"
export * from "./SaleOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f63e7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f63e7f6')) {
      api.createRecord('6f63e7f6', component.options)
    } else {
      api.reload('6f63e7f6', component.options)
    }
    module.hot.accept("./SaleOrderForm.vue?vue&type=template&id=6f63e7f6&scoped=true&", function () {
      api.rerender('6f63e7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/components/forms/SaleOrderForm.vue"
export default component.exports